const RELOAD_KEY = 'esep.chunkReloadAt';

// After a deploy the lazy chunks of the previous build may be gone. Such a failure is
// fixed by loading the new build, so the page reloads itself once (at most every 10 s).
export const isChunkError = (e) =>
  e?.name === 'ChunkLoadError' || /Loading (CSS )?chunk|dynamically imported module/i.test(e?.message || '');

export function shouldReloadForChunk(error) {
  if (!isChunkError(error)) return false;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
    if (Date.now() - last < 10_000) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}
